const constants={
//    "BASE_URL": 'https://dev.api.mplb.givesome.org/api/',//DEV
//     "FILE_UPLOAD_BUCKETNAME": 'martinrea',//DEV

    //  "BASE_URL": 'https://qa.api.mplb.givesome.org/api/', //UAT
    //  "BASE_URL": 'https://d7d2-2406-7400-c6-2903-1185-d726-8e4c-de84.ngrok-free.app/api/', //UAT

     "BASE_URL": 'https://qa.martinreamplb.com:8443/api/', //  NEW UAT
     "FILE_UPLOAD_BUCKETNAME": 'martinrea',//UAT
     "ENCRYPTION_SECRET_KEY" : 'mplbmartinrea78967', // Make sure to use a strong, secure key


    // "BASE_URL": 'https://martinreamplb.com:8443/api/', //PROD
    // "FILE_UPLOAD_BUCKETNAME": 'martinrea_prod',//PROD
    // "ENCRYPTION_SECRET_KEY" : 'mplbmartinrea78967', // Make sure to use a strong, secure key

    // BASE_URL:'https://de1e-2406-7400-c6-ccfc-1c07-a79d-adf3-f72c.ngrok-free.app/api/', // Aruna
    // BASE_URL:'https://97cd-2401-4900-7b82-4ea8-7460-f125-6e7f-6503.ngrok-free.app/api/', // Ganesh
    "PAGINATION_LIMIT":12,
    "PAGINATION_START":1,
    "MODEL_LIMIT":100,
    "DEALER_LIMIT":50,
    "FILE_UPLOADER_URL":"https://mincandev.kyybaapps.com",
    "langs" : {
        "en": "English",
        "gr": "German",
        "sp_mex": "Spanish (Mexico)",
        "sp_sp": "Spanish (Spain)",
        "sl": "Slovakia",
        "ch": "Chinese",
        "pr": "Portuguese"
      }
}
export default constants;